<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-expansion-panels
          :value="expansionPanelsAbertos"
          focusable
        >
          <v-expansion-panel>
            <v-expansion-panel-header class="d-flex justify-space-between">
              <span class="font-weight-medium text-h6">Sla de Resolução</span>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-row>
                <v-col
                  md="4"
                  cols="12"
                >
                  <v-switch
                    v-model="permitirSlaResolucao"
                    label="SLA de Resolução"
                  />
                </v-col>
              </v-row>

              <v-expand-transition>
                <v-row v-if="permitirSlaResolucao">
                  <v-col
                    md="6"
                    cols="12"
                  >
                    <v-text-field
                      v-model="diasSlaResolucao"
                      label="Dias"
                      type="number"
                      dense
                      outlined
                      min="0"
                      max="31"
                      :prepend-icon="icons.mdiCalendarToday"
                      @change="handleSlaResolucaoChange"
                    />
                  </v-col>

                  <v-col
                    md="6"
                    cols="12"
                  >
                    <v-dialog
                      ref="slaDialog"
                      v-model="modalSlaDialog"
                      :return-value.sync="horasMinutosSlaResolucao"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="horasMinutosSlaResolucao"
                          label="Horas e minutos"
                          :prepend-icon="icons.mdiClockTimeFourOutline"
                          readonly
                          v-bind="attrs"
                          dense
                          outlined
                          v-on="on"
                        />
                      </template>

                      <v-time-picker
                        v-if="modalSlaDialog"
                        v-model="horasMinutosSlaResolucao"
                        full-width
                        format="24hr"
                      >
                        <v-spacer></v-spacer>

                        <v-btn
                          text
                          color="primary"
                          @click="modalSlaDialog = false"
                        >
                          Cancel
                        </v-btn>

                        <v-btn
                          text
                          color="primary"
                          @click="
                            $refs.slaDialog.save(horasMinutosSlaResolucao)
                            handleSlaResolucaoChange()
                          "
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-col>

                  <v-col cols="12">
                    <sla-configuracao-alerta
                      :sla-alertas.sync="slaResolucaoDataLocale.alertas"
                      :niveis-alerta="niveisAlerta"
                      :get-is-alerta-valido="getIsAlertaValido"
                    />
                  </v-col>
                </v-row>
              </v-expand-transition>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <v-row class="justify-center mt-5">
      <v-btn
        class="mr-4"
        color="secondary"
        outlined
        :disabled="loading"
        @click="resetForm"
      >
        Cancelar
      </v-btn>

      <v-btn
        color="primary"
        @click="updateSlaTipoSolicitacao"
      >
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="secondary"
        />
        <span v-else>{{ btnTitle }}</span>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { mdiCalendarToday, mdiClockTimeFourOutline } from '@mdi/js'
import { computed, ref, watch } from '@vue/composition-api'
import SlaConfiguracaoAlerta from './configuracao-alerta/SlaConfiguracaoAlerta.vue'
import SlaTipoEnum from '@/models/entities/sla/SlaTipoEnum'

export default {
  components: {
    SlaConfiguracaoAlerta,
  },

  emits: ['reset', 'update:slas'],

  props: {
    slas: {
      type: Array,
      default: null,
    },
    expansionPanelsAbertos: {
      type: Array,
      required: true,
    },
    niveisAlerta: {
      type: Object,
      required: true,
    },
    btnTitle: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    getIsAlertaValido: {
      type: Function,
      required: true,
    },
  },

  setup(props, { emit }) {
    const blankSlaData = {
      tipoSlaId: SlaTipoEnum.FinalizacaoTicket,
      tempoSlaEmMinutos: 0,
      alertas: [],
    }

    const permitirSlaResolucao = ref(false)

    const slaResolucaoDataLocale = ref(JSON.parse(JSON.stringify(blankSlaData)))

    const modalSlaDialog = ref(false)

    const slaFunctions = {
      dias: totalmins => {
        const hours = Math.floor(totalmins / 60)
        const days = Math.floor(hours / 24)

        return days
      },
      horasMinutos: totalmins => {
        const mins = String(totalmins % 60).padStart(2, '0')
        const hours = Math.floor(totalmins / 60)
        const hourss = String(hours % 24).padStart(2, '0')

        return `${hourss}:${mins}`
      },
    }

    const diasSlaResolucao = ref(slaFunctions.dias(0))
    const horasMinutosSlaResolucao = ref(slaFunctions.horasMinutos(0))
    const valorSlaResolucao = ref(0)

    const erroSlaResolucao = computed(() => {
      if (!permitirSlaResolucao.value) {
        return false
      }

      if (valorSlaResolucao.value > 0 && valorSlaResolucao.value < 10) {
        return 'A SLA de resolução deve ser de pelo menos 10 minutos.'
      }

      return false
    })

    function handleSlaResolucaoChange() {
      valorSlaResolucao.value = diasSlaResolucao.value * 24 * 60 + horasMinutosSlaResolucao.value.split(':')[0] * 60 + horasMinutosSlaResolucao.value.split(':')[1] * 1

      if (valorSlaResolucao.value > 0 && valorSlaResolucao.value < 10) {
        Vue.$toast.clear()
        Vue.$toast.warning('A SLA de resolução deve ser de pelo menos 10 minutos.', { timeout: false })
      }
    }

    watch(
      () => props.slas,
      newValue => {
        const slaResolucao = newValue?.find(it => it.tipoSlaId === SlaTipoEnum.FinalizacaoTicket)

        permitirSlaResolucao.value = slaResolucao?.alertas.some(props.getIsAlertaValido)

        slaResolucaoDataLocale.value = JSON.parse(JSON.stringify(slaResolucao || blankSlaData))

        diasSlaResolucao.value = slaFunctions.dias(slaResolucaoDataLocale.value.tempoSlaEmMinutos || 0)
        horasMinutosSlaResolucao.value = slaFunctions.horasMinutos(slaResolucaoDataLocale.value.tempoSlaEmMinutos || 0)
        valorSlaResolucao.value = diasSlaResolucao.value * 24 * 60 + horasMinutosSlaResolucao.value.split(':')[0] * 60 + horasMinutosSlaResolucao.value.split(':')[1] * 1
      },
      { deep: true, immediate: true },
    )

    function resetForm() {
      diasSlaResolucao.value = slaFunctions.dias(slaResolucaoDataLocale.value.tempoSlaEmMinutos || 0)
      horasMinutosSlaResolucao.value = slaFunctions.horasMinutos(slaResolucaoDataLocale.value.tempoSlaEmMinutos || 0)

      emit('reset')
    }

    function updateSlaTipoSolicitacao() {
      if (erroSlaResolucao.value) {
        Vue.$toast.clear()
        Vue.$toast.error(erroSlaResolucao.value)
        return
      }

      const slaResolucaoCopy = JSON.parse(JSON.stringify(slaResolucaoDataLocale.value))

      const slas = []

      if (permitirSlaResolucao.value && slaResolucaoCopy) {
        slas.push({ ...slaResolucaoCopy, tempoSlaEmMinutos: valorSlaResolucao.value })
      }

      emit('update:slas', slas)
    }

    return {
      permitirSlaResolucao,

      slaResolucaoDataLocale,

      modalSlaDialog,

      diasSlaResolucao,
      horasMinutosSlaResolucao,
      valorSlaResolucao,
      handleSlaResolucaoChange,

      resetForm,
      updateSlaTipoSolicitacao,

      icons: {
        mdiClockTimeFourOutline,
        mdiCalendarToday,
      },
    }
  },
}
</script>
